.page {
  padding: 24px var(--space-5) 80px;
  max-width: 1100px;
  margin: 0 auto;
  background: #fff;
}

.head { margin-bottom: 16px; }

.back {
  font-size: 0.78rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--color-ink-soft);
}

.title {
  font-family: var(--font-display);
  font-size: 2rem;
  margin: 6px 0 6px;
  letter-spacing: 0.04em;
}

.lede {
  margin: 0 0 12px;
  color: var(--color-ink-soft);
  font-size: 0.95rem;
}

.empty { color: var(--color-ink-soft); padding: 16px 0; }

.group {
  margin-top: 28px;
  border: 1px solid rgba(0,0,0,0.08);
  border-radius: 10px;
  padding: 16px;
  background: var(--color-bone);
}

.groupHead {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 10px;
  flex-wrap: wrap;
  gap: 8px;
}

.groupTitle {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  display: inline-flex;
  gap: 8px;
  align-items: center;
}

.flag { font-size: 1.2em; }

.groupTotals {
  font-size: 0.85rem;
  color: var(--color-ink-soft);
}

.table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
}

.table thead th {
  text-align: left;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--color-ink-soft);
  font-weight: 700;
  padding: 10px 12px;
  background: #fff;
  border-bottom: 1px solid rgba(0,0,0,0.06);
}

.table tbody td {
  padding: 12px;
  border-bottom: 1px solid rgba(0,0,0,0.05);
  font-size: 0.92rem;
  vertical-align: middle;
}

.colCenter { text-align: center; }
.colRight  { text-align: right; }

.itemCell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.thumb {
  width: 48px;
  height: 48px;
  object-fit: cover;
  background: var(--color-bone);
  border-radius: 4px;
}

.name {
  font-weight: 600;
}

.sub {
  font-size: 0.78rem;
  color: var(--color-ink-soft);
}

.skuLine {
  font-size: 0.7rem;
  color: var(--color-ink-soft);
  letter-spacing: 0.06em;
}

.stockWarn {
  margin-top: 4px;
  font-size: 0.78rem;
  font-weight: 700;
  color: #b53b3b;
  letter-spacing: 0.02em;
}

.removeBtn {
  background: transparent;
  border: 0;
  cursor: pointer;
  font-size: 1.2rem;
  color: var(--color-ink-soft);
  padding: 4px 8px;
  line-height: 1;
}

.removeBtn:hover { color: #b53b3b; }

.foot {
  margin-top: 28px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.summary {
  align-self: flex-end;
  min-width: 280px;
  background: var(--color-bone);
  padding: 12px 16px;
  border-radius: 8px;
}

.summaryRow {
  display: flex;
  justify-content: space-between;
  font-size: 0.95rem;
  padding: 4px 0;
}

.summaryTotal {
  font-size: 1.15rem;
  font-weight: 700;
  border-top: 1px solid rgba(0,0,0,0.08);
  margin-top: 6px;
  padding-top: 8px;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .page { padding: 16px var(--space-4) 40px; }
  .title { font-size: 1.5rem; }
  .table thead { display: none; }
  .table, .table tbody, .table tr, .table td {
    display: block;
    width: 100%;
  }
  .table tr {
    border-bottom: 1px solid rgba(0,0,0,0.08);
    padding: 10px 4px;
  }
  .table tbody td {
    padding: 4px 8px;
    border: 0;
  }
  .colCenter, .colRight { text-align: left; }
  .summary { width: 100%; align-self: stretch; }
  .actions { justify-content: stretch; }
  .actions > * { flex: 1; }
}
